import React from "react";
import { connect } from "react-redux";
import ZonesTable from "./ZonesTable";
import CirclesTable from "./CirclesTable";
import { bindActionCreators } from "redux";
import HighwaysTable from "./HighwaysTable";
import { useHistory } from "react-router-dom";
import TableSearch from "../../../../Components/TableSearch";
import { getDistricts } from "../../../../actionCreators/DropDown";
import { Typography, Row, Col, Button, Card, Select, Spin } from "antd";
import { getLookupTableData } from "../../../../actionCreators/Property";
import InputLabel from "../../../../Components/FloatingSelectLabel/FloatingSelectLabel";
import {
  getDistrictCircles,
  getHighwaysOfDistrict,
  getZonesbyDistrict,
} from "../../../../actionCreators/Zones";
import { downloadFile } from "../../../../utils/downloadFile";
import { getTehsilesbyDistrict } from "../../../../actionCreators/Tehsiles"
import { transformFilterMetaData } from "../../../../utils";
import { getFilterMetaData } from "../../../../actionCreators/Property"
import { getMouzasbyDistrict } from "../../../../actionCreators/Mouzas"

const { Option } = Select;

function LookupTable({
  districts,
  getDistricts,
  filterMetaData,
  lookupTableData,
  mouzasOfDistrict,
  getFilterMetaData,
  tehsilesOfDistrict,
  getDistrictCircles,
  getZonesbyDistrict,
  getLookupTableData,
  getMouzasbyDistrict,
  getHighwaysOfDistrict,
  getTehsilesOfDistrict,
}) {
  const history = useHistory();
  const [statusSelectActive, setStatusSelectActive] = React.useState(false);
  const [selectedDistrict, setSelectedDistrict] = React.useState(null);
  const [allowTableReset, setAllowTableReset] = React.useState(false);
  const [tableFilters, setTableFilters] = React.useState(null);
  const getDistrictOptions = (districtList) =>
    districtList?.map((x) => <Option value={x?.id}>{x?.name}</Option>);

  React.useEffect(() => {
    getDistricts();
    getFilterMetaData()
  }, []);

  React.useEffect(() => {
    if (districts?.data) {
      const districtId = localStorage?.getItem("districtSelected");
      if (districtId) {
        const selectedDistrict = JSON?.parse(districtId);
        if (selectedDistrict) {
          setSelectedDistrict(selectedDistrict);
        }
        return () => {
          localStorage.removeItem("districtSelected");
        };
      }
    }
  }, [districts]);

  React.useEffect(() => {
    if (selectedDistrict !== null) {
      setAllowTableReset(true);
      setTableFilters(null); //reset table filters
      getLookupTableData({
        page: 1,
        pageSize: 10,
        districtId: selectedDistrict,
      });
      getDistrictCircles({ district_id: selectedDistrict, page: 1, limit: 5 });
      getZonesbyDistrict({ district_id: selectedDistrict, page: 1, limit: 5 });
      getHighwaysOfDistrict({
        district_id: selectedDistrict,
        page: 1,
        limit: 5,
      });      
      getTehsilesOfDistrict({district_id: selectedDistrict})
      getMouzasbyDistrict({district_id: selectedDistrict})

    }
  }, [selectedDistrict]);
  React.useEffect(() => {
    if (tableFilters !== null) {
      getLookupTableData({ ...tableFilters, districtId: selectedDistrict });
    }
  }, [tableFilters]);

  const exportToCsv = (e) => {
    e.preventDefault();
    downloadFile({
      districtId: selectedDistrict,
      fileType: "text/csv",
    });
  };

  return (
    <React.Fragment>
      {[undefined, null].includes(districts) ? (
        <div className="spin-loader">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div className="header" style={{ margin: "0px 10px" }}>
            <Typography className="heading">Lookup Data</Typography>
            {lookupTableData?.data?.data?.length && selectedDistrict ? (
              <Button
                className="export-report-button"
                type="primary"
                onClick={exportToCsv}
              >
                <span className="download-error-button-text">DOWNLOAD</span>
              </Button>
            ) : (
              ""
            )}
          </div>
          <div className="logs-body" style={{ marginBottom: "20px" }}>
            <div className="data-upload-header">Select District</div>
            <div
              onFocus={() => {
                setStatusSelectActive(true);
              }}
              onBlur={() => {
                setStatusSelectActive(false);
              }}
              className="dropdowns"
            >
              <InputLabel
                value={selectedDistrict}
                labelText="District"
                active={statusSelectActive}
              >
                <Select
                  disabled={false}
                  value={selectedDistrict}
                  onChange={setSelectedDistrict}
                  size="large"
                  loading={districts?.loading ? true : false}
                >
                  {getDistrictOptions(districts?.data)}
                </Select>
              </InputLabel>
            </div>
          </div>
          {selectedDistrict && (
            <>
              <TableSearch
                onRowClick={(x) => {
                  history.push({
                    pathname: `/admin/update-lookup-record`,
                    state: x,
                  });
                }}
                tableName={"lookupData"}
                data={lookupTableData?.data}
                resetLookupState={allowTableReset}
                resetLookupParentState={() => setAllowTableReset(false)}
                sendRequestParams={(x) =>
                  setTableFilters({
                    page: x?.page,
                    pageSize: x?.size,
                    searchString: x?.searchText,
                    filterBody: JSON.stringify(x?.filterBody),
                  })
                }
                loading={lookupTableData?.loading}
                filterMetaData={{
                  ...transformFilterMetaData(filterMetaData?.data), 
                  tehsiles: tehsilesOfDistrict?.data?.data?.map((tehsile) => ({ value: tehsile.id, text: tehsile.name })), 
                  mouzas: mouzasOfDistrict?.data?.data?.map((mouza) => ({ value: mouza.id, text: mouza.name }))}}
              />
              <ZonesTable district={selectedDistrict} />
              <CirclesTable district={selectedDistrict} />
              <HighwaysTable district={selectedDistrict} />
            </>
          )}
        </>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = ({
  user: user,
  dropDown: { districts },
  property: { lookupTableData, filterMetaData },
  tehsile: { tehsilesOfDistrict },
  mouza: { mouzasOfDistrict }
}) => ({
  user,
  districts,
  lookupTableData,
  filterMetaData,
  tehsilesOfDistrict,
  mouzasOfDistrict
});

const mapDispatchToProps = (dispatch) => ({
  getDistricts: bindActionCreators(getDistricts, dispatch),
  getLookupTableData: bindActionCreators(getLookupTableData, dispatch),
  getDistrictCircles: bindActionCreators(getDistrictCircles, dispatch),
  getZonesbyDistrict: bindActionCreators(getZonesbyDistrict, dispatch),
  getHighwaysOfDistrict: bindActionCreators(getHighwaysOfDistrict, dispatch),
  getTehsilesOfDistrict:bindActionCreators(getTehsilesbyDistrict, dispatch),
  getFilterMetaData: bindActionCreators(getFilterMetaData, dispatch),
  getMouzasbyDistrict: bindActionCreators(getMouzasbyDistrict, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LookupTable);
